import {
  PRIX_GRAVURE,
  PRIX_PHOTO_PERSO,
  diametres,
  frames,
  hands,
  mecanismes,
} from '../data/options'
import type { Configuration } from '../types/clock'

export type LignePrix = { label: string; montant: number }

export function detailPrix(config: Configuration): LignePrix[] {
  const lignes: LignePrix[] = []

  const taille = diametres.find((d) => d.value === config.diametre)
  if (taille) {
    lignes.push({ label: `Horloge ${taille.label}`, montant: taille.prix })
  }

  if (config.photoPerso) {
    lignes.push({ label: 'Impression de votre photo', montant: PRIX_PHOTO_PERSO })
  }

  const cadre = frames.find((f) => f.value === config.frame)
  if (cadre && cadre.prix > 0) {
    lignes.push({ label: `Cadre ${cadre.label.toLowerCase()}`, montant: cadre.prix })
  }

  const aiguilles = hands.find((h) => h.value === config.hands)
  if (aiguilles && aiguilles.prix > 0) {
    lignes.push({ label: `Aiguilles ${aiguilles.label.toLowerCase()}`, montant: aiguilles.prix })
  }

  const mecanisme = mecanismes.find((m) => m.value === config.mecanisme)
  if (mecanisme && mecanisme.prix > 0) {
    lignes.push({ label: mecanisme.label, montant: mecanisme.prix })
  }

  if (config.texte.trim() || config.sousTexte.trim()) {
    lignes.push({ label: 'Personnalisation du texte', montant: PRIX_GRAVURE })
  }

  return lignes
}

export function totalPrix(config: Configuration): number {
  return detailPrix(config).reduce((somme, ligne) => somme + ligne.montant, 0)
}

export function formatPrix(montant: number): string {
  return `${montant.toFixed(2).replace('.', ',')} €`
}
